import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';
import Footer from '../Footer';

const pb = new PocketBase('https://bahcarplaza.com');
const CITIES = ['Kolkata', 'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Pune', 'Hyderabad', 'Ahmedabad', 'Jaipur'];

const STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", 
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", 
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", 
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", 
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", 
  "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];

const MENU_ITEMS = [
  { name: 'My Bookings', icon: '🗓️' },
  { name: 'My Orders', icon: '📦' },
  { name: 'My Ad', icon: '🚗' },
  { name: 'Post Ad', icon: '🏷️' },
  { name: 'Wishlist', icon: '❤️' },
  { name: 'Analytics', icon: '📊' },
  { name: 'Wallet', icon: '💰' },
  { name: 'My Address', icon: '📍' }, 
  { name: 'Profile Update', icon: '⚙️' }
];

function Account({ view, setView, setSelectedCar, activeTab, setActiveTab }) {
  const [localTab, setLocalTab] = useState('My Bookings');
  const currentTab = activeTab || localTab;
  
  const [isMobileAccountMenuOpen, setIsMobileAccountMenuOpen] = useState(false);
  
  const handleTabChange = (tab) => {
    setLocalTab(tab);
    if (setActiveTab) setActiveTab(tab);
    setIsMobileAccountMenuOpen(false); 
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  const [myCars, setMyCars] = useState([]);
  const [myOrders, setMyOrders] = useState([]); 
  const [favCars, setFavCars] = useState([]); 
  const [myBookings, setMyBookings] = useState([]);
  const [userData, setUserData] = useState(pb.authStore.model || {});

  const [editingCarId, setEditingCarId] = useState(null);
  const [sellCarData, setSellCarData] = useState({
    brand: '', model: '', year: '', price: '', kilometers_driven: '', mileage: '', owner_type: '',
    fuel_type: [], transmission: [], city: [], color: [], commission_amount: 0
  });
  const [sellCarImages, setSellCarImages] = useState(null); 
  const [profileImage, setProfileImage] = useState(null); 

  const [profileData, setProfileData] = useState({
    name: pb.authStore.model?.name || '', 
    phone: pb.authStore.model?.phone || '', 
    city: pb.authStore.model?.city || ''
  });

  const [addressData, setAddressData] = useState({
    address_line: pb.authStore.model?.address_line || '',
    landmark: pb.authStore.model?.landmark || '',
    city: pb.authStore.model?.city || '',
    state: pb.authStore.model?.state || '',
    pin_code: pb.authStore.model?.pin_code || ''
  });

  // 🚨 NEW: Wallet State 🚨
  const [rechargeAmount, setRechargeAmount] = useState('');
  const [isRecharging, setIsRecharging] = useState(false);

  const fetchAccountData = async () => {
    try {
      const uid = pb.authStore.model?.id;
      if (!uid) return;

      const [carsData, ords, wish, books, user] = await Promise.all([
        pb.collection('cars').getFullList({ filter: `added_by = "${uid}"`, sort: '-created' }),
        pb.collection('orders').getFullList({ filter: `user_id = "${uid}"`, expand: 'car_id', sort: '-created' }),
        pb.collection('wishlist').getFullList({ filter: `user_id = "${uid}"`, expand: 'car_id' }),
        pb.collection('bookings').getFullList({ filter: `user_id = "${uid}"`, expand: 'car_id', sort: '-created' }),
        pb.collection('users').getOne(uid)
      ]);
      
      setMyCars(carsData); setMyOrders(ords); setFavCars(wish); setMyBookings(books); setUserData(user);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (!pb.authStore.isValid) {
      setView('auth');
      return;
    }
    fetchAccountData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab]); 

  // 🚨 Load Razorpay Script for Wallet Recharge 🚨
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (currentTab === 'Profile Update') {
      setProfileData({
        name: userData.name || pb.authStore.model?.name || '',
        phone: userData.phone || pb.authStore.model?.phone || '',
        city: userData.city || pb.authStore.model?.city || ''
      });
    }
    if (currentTab === 'My Address') {
      setAddressData({
        address_line: userData.address_line || pb.authStore.model?.address_line || '',
        landmark: userData.landmark || pb.authStore.model?.landmark || '',
        city: userData.city || pb.authStore.model?.city || '',
        state: userData.state || pb.authStore.model?.state || '',
        pin_code: userData.pin_code || pb.authStore.model?.pin_code || ''
      });
    }
  }, [currentTab, userData]);

  const getVal = (val) => (Array.isArray(val) ? val[0] : val || "");

  const toggleSelection = (field, value) => {
    setSellCarData(prev => {
      const currentList = prev[field];
      if (currentList.includes(value)) return { ...prev, [field]: currentList.filter(item => item !== value) };
      return { ...prev, [field]: [...currentList, value] };
    });
  };

  const handleLogout = () => { pb.authStore.clear(); setUserData({}); setView('home'); window.location.reload(); };

  const handleEditClick = (car) => {
    setEditingCarId(car.id);
    setSellCarData({
      brand: car.brand || '', model: car.model || '', year: car.year || '', price: car.price || '',
      kilometers_driven: car.kilometers_driven || '', mileage: car.mileage || '', owner_type: car.owner_type || '',
      fuel_type: Array.isArray(car.fuel_type) ? car.fuel_type : (car.fuel_type ? [car.fuel_type] : []),
      transmission: Array.isArray(car.transmission) ? car.transmission : (car.transmission ? [car.transmission] : []),
      city: Array.isArray(car.city) ? car.city : (car.city ? [car.city] : []),
      color: Array.isArray(car.color) ? car.color : (car.color ? [car.color] : [])
    });
    handleTabChange('Post Ad');
  };

  const handleSellCarSubmit = async (e) => {
    e.preventDefault();
    if(sellCarData.color.length === 0 || sellCarData.fuel_type.length === 0 || sellCarData.transmission.length === 0 || sellCarData.city.length === 0) {
      alert("Please ensure Color, City, Fuel, and Transmission are selected."); return;
    }
    try {
      const formData = new FormData();
      formData.append('brand', sellCarData.brand); formData.append('model', sellCarData.model);
      formData.append('year', sellCarData.year); formData.append('price', sellCarData.price);
      formData.append('mileage', sellCarData.mileage); formData.append('kilometers_driven', sellCarData.kilometers_driven);
      formData.append('owner_type', sellCarData.owner_type); formData.append('status', 'Pending');
      formData.append('rejection_reason', '');
      formData.append('user_car', true); formData.append('added_by', pb.authStore.model.id);
      
      sellCarData.color.forEach(v => formData.append('color', v));
      sellCarData.fuel_type.forEach(v => formData.append('fuel_type', v));
      sellCarData.transmission.forEach(v => formData.append('transmission', v));
      sellCarData.city.forEach(v => formData.append('city', v));
      if (sellCarImages && sellCarImages.length > 0) { Array.from(sellCarImages).forEach(file => { formData.append('image', file); }); }
      
      if (editingCarId) {
        await pb.collection('cars').update(editingCarId, formData);
        alert("Car Listing Updated & Resubmitted for Admin Approval!");
      } else {
        await pb.collection('cars').create(formData);
        alert("Car Listed Successfully! Wait for Admin Approval.");
      }
      
      setSellCarData({ brand: '', model: '', year: '', price: '', kilometers_driven: '', mileage: '', owner_type: '', fuel_type: [], transmission: [], city: [], color: [] });
      setSellCarImages(null); setEditingCarId(null); handleTabChange('My Ad'); fetchAccountData();
    } catch (e) { alert("Submission Failed: " + e.message); }
  };

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    try { 
      const formData = new FormData();
      formData.append('name', profileData.name); 
      formData.append('phone', profileData.phone); 
      formData.append('city', profileData.city);
      if (profileImage) { formData.append('avatar', profileImage); }
      
      await pb.collection('users').update(pb.authStore.model.id, formData); 
      
      const updatedUser = await pb.collection('users').getOne(pb.authStore.model.id);
      pb.authStore.save(pb.authStore.token, updatedUser);

      alert("Profile updated successfully!"); 
      setProfileImage(null); 
      fetchAccountData(); 
    } 
    catch (e) { alert("Update failed: " + e.message); }
  };

  const handleAddressUpdate = async (e) => {
    e.preventDefault();
    try {
      await pb.collection('users').update(pb.authStore.model.id, addressData);
      
      const updatedUser = await pb.collection('users').getOne(pb.authStore.model.id);
      pb.authStore.save(pb.authStore.token, updatedUser);

      alert("Address saved successfully!");
      fetchAccountData();
    } catch (e) {
      alert("Failed to save address: " + e.message);
    }
  };

  const deleteRecord = async (collection, id) => {
    if (window.confirm("Are you sure you want to delete this?")) {
      try { await pb.collection(collection).delete(id); fetchAccountData(); } catch (e) { alert("Delete failed: " + e.message); }
    }
  };

  // ==========================================
  // 🚨 CUSTOMER WALLET RECHARGE LOGIC 🚨
  // ==========================================
  const handleWalletRecharge = async () => {
    const amount = Number(rechargeAmount);
    if (!amount || amount <= 0) {
      alert("Please enter a valid amount to recharge.");
      return;
    }

    setIsRecharging(true);

    try {
      // 1. Create order in Backend
      const response = await fetch('https://bahcarplaza.com/payment/api/razorpay/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: amount,
          receiptId: `wallet_${pb.authStore.model.id}_${Date.now()}`
        })
      });

      const data = await response.json();

      if (!data.success) {
        alert("Payment Initialization Failed!");
        setIsRecharging(false);
        return;
      }

      // 2. Razorpay Pop-up
      const options = {
        key: data.keyId,
        amount: data.order.amount,
        currency: "INR",
        name: "Bah! Car Plaza Wallet",
        description: "Wallet Recharge",
        image: "https://cdn-icons-png.flaticon.com/512/3202/3202926.png",
        order_id: data.order.id,
        handler: async function (response) {
          try {
            // 3. Update Database Balance on Success
            const currentBalance = userData.wallet_balance || 0;
            const newBalance = currentBalance + amount;

            await pb.collection('users').update(pb.authStore.model.id, { 
              wallet_balance: newBalance 
            });

            // Update App State
            const updatedUser = await pb.collection('users').getOne(pb.authStore.model.id);
            pb.authStore.save(pb.authStore.token, updatedUser);
            setUserData(updatedUser);
            
            setRechargeAmount('');
            alert(`🎉 Success! ₹${amount.toLocaleString()} has been added to your wallet.`);
            setIsRecharging(false);
          } catch (updateError) {
            console.error(updateError);
            alert("Payment successful but failed to update wallet. Contact Support.");
            setIsRecharging(false);
          }
        },
        prefill: {
          name: userData?.name || "",
          email: userData?.email || "",
          contact: userData?.phone || ""
        },
        theme: {
          color: "#002f34"
        },
        modal: {
          ondismiss: function() {
            setIsRecharging(false);
          }
        }
      };

      const razorpayObject = new window.Razorpay(options);
      
      razorpayObject.on('payment.failed', function (response) {
        alert("❌ Payment Failed. Please try again.");
        setIsRecharging(false);
      });

      razorpayObject.open();

    } catch (error) {
      console.error(error);
      alert("Server Error! Could not connect to payment gateway.");
      setIsRecharging(false);
    }
  };

  const inputStyle = { padding: '15px', borderRadius: '15px', border: '1px solid #eee', backgroundColor: '#f9f9f9', fontWeight: 'bold', width: '100%', boxSizing: 'border-box' };

  return (
    <div style={{ backgroundColor: '#f4f7f6', minHeight: '100vh', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column' }}>
      
      <style>
        {`
          .account-layout { display: flex; gap: 30px; padding: 40px; max-width: 1400px; width: 100%; margin: 0 auto; box-sizing: border-box; }
          .account-sidebar { width: 280px; flex-shrink: 0; background-color: #fff; border-radius: 30px; padding: 30px; box-shadow: 0 10px 30px rgba(0,0,0,0.03); height: fit-content; position: sticky; top: 40px; }
          
          .account-content { flex: 1; background-color: #fff; border-radius: 40px; padding: 50px; box-shadow: 0 10px 30px rgba(0,0,0,0.03); }
          
          .grid-2-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 25px; }
          .grid-3-cols { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 25px; }
          .booking-card { display: grid; grid-template-columns: 120px 1fr auto; gap: 25px; align-items: center; }
          .flex-between { display: flex; justify-content: space-between; align-items: center; }
          .flex-start { display: flex; gap: 25px; align-items: center; }
          .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 40px; border-bottom: 2px solid #f3f4f6; padding-bottom: 20px; }
          
          .mobile-menu-wrapper { display: none; }
          
          @media (max-width: 900px) {
            .account-layout { padding: 15px; flex-direction: column; }
            .account-sidebar { display: none; } 
            .account-content { padding: 25px 20px; border-radius: 25px; }
            .grid-2-cols, .grid-3-cols { grid-template-columns: 1fr; }
            
            .page-header { display: flex; flex-direction: row; align-items: center !important; justify-content: space-between; gap: 10px; margin-bottom: 20px; padding-bottom: 15px; }
            .header-title-row { display: flex; justify-content: flex-start; align-items: center; gap: 10px; flex: 1; }
            .page-title-text { font-size: 18px !important; margin: 0; white-space: nowrap; }
            
            .back-home-btn { 
              width: 40px !important; 
              height: 40px !important; 
              padding: 0 !important; 
              border-radius: 50% !important; 
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              flex-shrink: 0;
            }
            
            .mobile-menu-wrapper { display: block; position: relative; }
            .mobile-menu-btn { background: #ef5e33; color: #fff; border: none; padding: 10px 15px; border-radius: 12px; font-weight: 900; font-size: 14px; cursor: pointer; display: flex; align-items: center; gap: 6px; box-shadow: 0 4px 10px rgba(239,94,51,0.2); }
            
            .mobile-dropdown-content { 
              position: absolute; top: 120%; left: 0; 
              background: #002f34; 
              width: 250px; 
              border-radius: 15px; 
              box-shadow: 0 15px 40px rgba(0,0,0,0.3); 
              border: 1px solid rgba(255,255,255,0.1); 
              z-index: 9999; padding: 15px; 
              display: flex; flex-direction: column; gap: 8px; 
            }
            .mobile-dropdown-content button { 
              padding: 12px 15px; text-align: left; background: none; border: none; border-radius: 10px; 
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
              font-weight: 800; font-size: 14px; 
              color: #b0c4c6; 
              cursor: pointer; transition: 0.3s;
              display: flex; align-items: center; gap: 12px;
              letter-spacing: 0.5px;
            }
            .mobile-dropdown-content button:hover { background: rgba(255,255,255,0.05); color: #fff; }
            .mobile-dropdown-content button.active { 
              background: #ef5e33; 
              color: #fff; 
              box-shadow: 0 4px 10px rgba(239,94,51,0.3);
            }
            .mobile-dropdown-logout {
              background: rgba(220, 53, 69, 0.1) !important;
              color: #ff6b6b !important;
              margin-top: 10px;
              justify-content: center;
            }
            .mobile-dropdown-logout:hover {
              background: #dc3545 !important;
              color: #fff !important;
            }
          }
          
          @media (max-width: 600px) {
            .booking-card { grid-template-columns: 1fr; text-align: center; }
            .mobile-full-img { width: 100% !important; height: 180px !important; margin: 0 auto; }
            .flex-between { flex-direction: column; text-align: center; gap: 15px; }
            .flex-start { flex-direction: column; text-align: center; gap: 15px; }
            .action-btn-group { align-items: center !important; }
          }
        `}
      </style>

      <main className="account-layout">
        
        {/* DESKTOP SIDEBAR */}
        <aside className="account-sidebar">
          <div style={{ textAlign: 'center', marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
            <div style={{ width: '70px', height: '70px', backgroundColor: '#ef5e33', borderRadius: '50%', margin: '0 auto 15px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '900', fontSize: '28px', textTransform: 'uppercase', boxShadow: '0 5px 15px rgba(239,94,51,0.3)', overflow: 'hidden' }}>
              {userData?.avatar ? (
                <img src={`https://bahcarplaza.com/api/files/${userData.collectionId}/${userData.id}/${userData.avatar}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Profile" />
              ) : (
                userData?.name?.charAt(0) || 'U'
              )}
            </div>
            <h3 style={{ margin: 0, color: '#002f34', fontWeight: '900', fontSize: '20px', textTransform: 'uppercase' }}>{userData?.name || 'User'}</h3>
            <p style={{ fontSize: '12px', color: '#aaa', marginTop: '5px' }}>{userData?.email || ''}</p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {MENU_ITEMS.map((item) => (
              <button key={item.name} onClick={() => {
                handleTabChange(item.name); setEditingCarId(null);
                setSellCarData({ brand: '', model: '', year: '', price: '', kilometers_driven: '', mileage: '', owner_type: '', fuel_type: [], transmission: [], city: [], color: [] });
                setSellCarImages(null);
              }} style={{
                padding: '15px 20px', textAlign: 'left', border: 'none', borderRadius: '15px', cursor: 'pointer', fontWeight: '900', transition: '0.3s', fontSize: '13px',
                backgroundColor: currentTab === item.name ? '#002f34' : '#f9f9f9', color: currentTab === item.name ? '#fff' : '#555',
                display: 'flex', alignItems: 'center', gap: '10px'
              }}>
                <span style={{ fontSize: '16px' }}>{item.icon}</span>
                {item.name}
              </button>
            ))}
          </div>
          <button onClick={handleLogout} style={{ width: '100%', backgroundColor: '#ffebeb', color: '#dc3545', padding: '15px', borderRadius: '15px', border: 'none', fontWeight: '900', fontSize: '13px', cursor: 'pointer', marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <span style={{ fontSize: '16px' }}>🚪</span> LOGOUT
          </button>
        </aside>

        <section className="account-content">
          
          <div className="page-header">
            <div className="header-title-row">
              
              {/* 📱 MOBILE DROPDOWN 📱 */}
              <div className="mobile-menu-wrapper">
                <button className="mobile-menu-btn" onClick={() => setIsMobileAccountMenuOpen(!isMobileAccountMenuOpen)}>
                  ☰ Menu
                </button>
                
                {isMobileAccountMenuOpen && (
                  <div className="mobile-dropdown-content">
                    {MENU_ITEMS.map((item) => (
                      <button 
                        key={item.name} 
                        className={currentTab === item.name ? 'active' : ''}
                        onClick={() => {
                          handleTabChange(item.name); setEditingCarId(null);
                          setSellCarData({ brand: '', model: '', year: '', price: '', kilometers_driven: '', mileage: '', owner_type: '', fuel_type: [], transmission: [], city: [], color: [] });
                          setSellCarImages(null);
                        }}
                      >
                        <span>{item.icon}</span> {item.name}
                      </button>
                    ))}
                    <button className="mobile-dropdown-logout" onClick={handleLogout}>
                      <span>🚪</span> LOGOUT
                    </button>
                  </div>
                )}
              </div>

              <h2 className="page-title-text" style={{ fontSize: '32px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontStyle: 'italic', margin: 0 }}>
                {currentTab === 'Post Ad' ? (editingCarId ? 'Edit Ad' : 'Post Ad') : currentTab}
              </h2>
            </div>

            <button 
              className="back-home-btn"
              title="Back to Home"
              onClick={() => setView('home')} 
              style={{ width: '45px', height: '45px', padding: '0', backgroundColor: '#002f34', color: '#fff', border: 'none', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', transition: '0.3s' }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#ef5e33'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#002f34'}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
            </button>
          </div>

          {currentTab === 'My Bookings' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {myBookings.length > 0 ? myBookings.map(b => (
                <div key={b.id} className="booking-card" style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '25px', border: '1px solid #eee', transition: '0.3s' }}>
                  <div className="mobile-full-img" onClick={() => { setSelectedCar(b.expand?.car_id); setView('details'); }} style={{ height: '90px', width: '120px', borderRadius: '15px', overflow: 'hidden', cursor: 'pointer' }}>
                    <img src={`https://bahcarplaza.com/api/files/${b.expand?.car_id?.collectionId}/${b.car_id}/${getVal(b.expand?.car_id?.image)}`} style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt="car" />
                  </div>
                  <div>
                    <h3 onClick={() => { setSelectedCar(b.expand?.car_id); setView('details'); }} style={{ margin: '0 0 10px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '22px', cursor: 'pointer' }}>{b.expand?.car_id?.brand} {b.expand?.car_id?.model}</h3>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', fontSize: '12px', fontWeight: 'bold', color: '#666', justifyContent: 'inherit' }}>
                      <span style={{ backgroundColor: '#fff', padding: '5px 12px', borderRadius: '10px', border: '1px solid #ddd' }}>🏷️ {b.visit_type}</span>
                      <span style={{ backgroundColor: '#fff', padding: '5px 12px', borderRadius: '10px', border: '1px solid #ddd' }}>🗓️ {new Date(b.booking_date).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</span>
                      <span style={{ backgroundColor: '#fff', padding: '5px 12px', borderRadius: '10px', border: '1px solid #ddd' }}>📞 {b.phone}</span>
                    </div>
                    {b.message && <p style={{ margin: '10px 0 0 0', fontSize: '13px', color: '#888', fontStyle: 'italic' }}>💬 "{b.message}"</p>}
                  </div>
                  <div className="action-btn-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '15px' }}>
                    <span style={{ fontSize: '11px', fontWeight: '900', color: b.status === 'Confirmed' ? '#fff' : '#002f34', backgroundColor: b.status === 'Confirmed' ? '#1db954' : '#f3f4f6', padding: '8px 20px', borderRadius: '20px', textTransform: 'uppercase' }}>{b.status}</span>
                  </div>
                </div>
              )) : <p style={{ color: '#ccc', fontWeight: 'bold', textAlign: 'center', padding: '50px' }}>No bookings found.</p>}
            </div>
          )}

          {currentTab === 'My Orders' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {myOrders.length > 0 ? myOrders.map(o => (
                <div key={o.id} className="flex-between" style={{ padding: '25px', backgroundColor: '#fff', borderRadius: '25px', border: '1px solid #eee', boxShadow: '0 5px 15px rgba(0,0,0,0.02)' }}>
                   <div className="flex-start">
                     <div className="mobile-full-img" onClick={() => { setSelectedCar(o.expand?.car_id); setView('details'); }} style={{ height: '70px', width: '100px', borderRadius: '12px', overflow: 'hidden', cursor: 'pointer' }}>
                       <img src={`https://bahcarplaza.com/api/files/${o.expand?.car_id?.collectionId}/${o.car_id}/${getVal(o.expand?.car_id?.image)}`} style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt="car" />
                     </div>
                     <div>
                       <h4 onClick={() => { setSelectedCar(o.expand?.car_id); setView('details'); }} style={{ margin: '0 0 5px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '20px', cursor: 'pointer' }}>🚗 {o.expand?.car_id?.brand} {o.expand?.car_id?.model}</h4>
                       <p style={{ margin: 0, fontSize: '12px', color: '#aaa', fontWeight: 'bold' }}>Order ID: #{o.id} • {new Date(o.created).toLocaleDateString()}</p>
                     </div>
                   </div>
                   
                   <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '12px' }}>
                     <h3 style={{ margin: 0, color: '#ef5e33', fontWeight: '900', fontSize: '24px' }}>₹{o.amount?.toLocaleString()}</h3>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                       <span style={{ fontSize: '11px', fontWeight: '900', color: '#fff', backgroundColor: o.payment_status === 'Processing' || o.payment_status === 'Delivered' || o.payment_status === 'Completed' ? '#1db954' : o.payment_status === 'Reject' || o.payment_status === 'Failed' ? '#dc3545' : '#f39c12', padding: '6px 15px', borderRadius: '20px', textTransform: 'uppercase' }}>
                         {o.payment_status}
                       </span>
                     </div>
                   </div>
                </div>
              )) : <p style={{ color: '#ccc', fontWeight: 'bold', textAlign: 'center', padding: '50px' }}>No purchase history found.</p>}
            </div>
          )}

          {currentTab === 'Post Ad' && (
            <form className="grid-2-cols" onSubmit={handleSellCarSubmit}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Brand Name</label>
                <select required style={inputStyle} value={sellCarData.brand} onChange={(e) => setSellCarData({ ...sellCarData, brand: e.target.value })}>
                  <option value="">Select Brand</option>
                  {['Maruti Suzuki','Hyundai','Honda','Tata','Mahindra','KIA','Toyota','Jaguar','Mercedes Benz','Landrover','Audi','BMW','Jeep','Ford','Skoda','Renault','MG','Volkswagen','Nissan','Datsun','Volvo','Chevrolet','CITROEN','Porsche','Force Motors','Ssangyong','BYD','Lexus','Mitsubishi','Fiat','Tesla'].map(b => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Model Name</label>
                <input required type="text" placeholder="e.g. Nexon XZ+" style={inputStyle} value={sellCarData.model} onChange={(e) => setSellCarData({ ...sellCarData, model: e.target.value })} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Manufacturing Year</label>
                <input required type="number" placeholder="2023" style={inputStyle} value={sellCarData.year} onChange={(e) => setSellCarData({ ...sellCarData, year: e.target.value })} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Expected Price (₹)</label>
                <input required type="number" placeholder="500000" style={inputStyle} value={sellCarData.price} onChange={(e) => setSellCarData({ ...sellCarData, price: e.target.value })} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Kilometers Driven</label>
                <input required type="number" placeholder="12000" style={inputStyle} value={sellCarData.kilometers_driven} onChange={(e) => setSellCarData({ ...sellCarData, kilometers_driven: e.target.value })} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Mileage (KMPL)</label>
                <input required type="number" placeholder="18" style={inputStyle} value={sellCarData.mileage} onChange={(e) => setSellCarData({ ...sellCarData, mileage: e.target.value })} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Owner Type</label>
                <select required style={inputStyle} value={sellCarData.owner_type} onChange={(e) => setSellCarData({ ...sellCarData, owner_type: e.target.value })}>
                  <option value="">Select Owner</option>
                  {['1st Hand', '2nd Hand', '3rd Hand', 'More Than 3'].map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>City</label>
                <select required style={inputStyle} value={sellCarData.city[0] || ""} onChange={(e) => setSellCarData({ ...sellCarData, city: [e.target.value] })}>
                  <option value="">Select City</option>
                  {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Car Color</label>
                <select required style={inputStyle} value={sellCarData.color[0] || ""} onChange={(e) => setSellCarData({ ...sellCarData, color: [e.target.value] })}>
                  <option value="">Select Color</option>
                  {['Maroon', 'Black', 'Silver', 'Gray', 'Blue', 'Red', 'White', 'Green', 'Brown', 'Orange', 'Golden', 'Yellow'].map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', gridColumn: '1 / -1' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Fuel Type</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {['Petrol', 'Disel', 'Electric', 'CNG'].map(f => (
                    <button type="button" key={f} onClick={() => toggleSelection('fuel_type', f)}
                      style={{ padding: '12px 20px', borderRadius: '12px', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer', border: '1px solid #eee', transition: '0.2s', backgroundColor: sellCarData.fuel_type.includes(f) ? '#002f34' : '#fff', color: sellCarData.fuel_type.includes(f) ? '#fff' : '#666' }}>
                      {f}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', gridColumn: '1 / -1' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Transmission</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {['Manual', 'Automatic'].map(t => (
                    <button type="button" key={t} onClick={() => toggleSelection('transmission', t)}
                      style={{ padding: '12px 20px', borderRadius: '12px', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer', border: '1px solid #eee', transition: '0.2s', backgroundColor: sellCarData.transmission.includes(t) ? '#002f34' : '#fff', color: sellCarData.transmission.includes(t) ? '#fff' : '#666' }}>
                      {t}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', gridColumn: '1 / -1' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Upload Images (Multiple)</label>
                <input required={!editingCarId} type="file" multiple accept="image/*" style={{ padding: '12px', borderRadius: '15px', border: '2px dashed #ccc', backgroundColor: '#f9f9f9', fontWeight: 'bold', cursor: 'pointer' }} onChange={(e) => setSellCarImages(e.target.files)} />
              </div>
              <button type="submit" style={{ gridColumn: '1 / -1', padding: '20px', backgroundColor: '#ef5e33', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: '900', fontSize: '16px', textTransform: 'uppercase', cursor: 'pointer', marginTop: '10px', boxShadow: '0 10px 30px rgba(239,94,51,0.3)', transition: '0.3s' }}>
                {editingCarId ? 'UPDATE & RESUBMIT' : 'Submit Listing for Review'}
              </button>
            </form>
          )}

          {currentTab === 'My Ad' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {myCars.length > 0 ? myCars.map(car => (
                <div key={car.id} className="flex-between" style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '25px', border: '1px solid #eee', boxShadow: '0 5px 15px rgba(0,0,0,0.02)' }}>
                  <div className="flex-start">
                    <img className="mobile-full-img" src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${getVal(car.image)}`} onClick={() => { setSelectedCar(car); setView('details'); }} style={{ width: '140px', height: '100px', borderRadius: '15px', objectFit: 'cover', cursor: 'pointer' }} alt="" />
                    <div>
                      <h4 onClick={() => { setSelectedCar(car); setView('details'); }} style={{ margin: '0 0 8px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '22px', cursor: 'pointer' }}>{car.brand} {car.model}</h4>
                      <p style={{ margin: 0, fontSize: '13px', color: '#888', fontWeight: 'bold' }}>🗓️ {car.year} &nbsp;•&nbsp; 🚗 {car.kilometers_driven} km &nbsp;•&nbsp; 📍 {getVal(car.city)}</p>
                      
                      {car.status === 'Rejected' && (
                        <div style={{ marginTop: '8px' }}>
                          <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#dc3545', fontWeight: 'bold', fontStyle: 'italic' }}>Reason: {car.rejection_reason}</p>
                          <button onClick={() => handleEditClick(car)} style={{ backgroundColor: '#002f34', color: '#fff', border: 'none', padding: '6px 15px', borderRadius: '10px', fontSize: '10px', fontWeight: '900', cursor: 'pointer', textTransform: 'uppercase' }}>EDIT & RESUBMIT</button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ textAlign: 'inherit' }}>
                    <h3 style={{ margin: '0 0 15px 0', color: '#ef5e33', fontWeight: '900', fontSize: '26px' }}>₹{car.price?.toLocaleString()}</h3>
                    <span style={{ fontSize: '11px', fontWeight: '900', backgroundColor: car.status === 'Approved' ? '#e1f9eb' : car.status === 'Rejected' ? '#ffebeb' : '#fff4e6', color: car.status === 'Approved' ? '#1db954' : car.status === 'Rejected' ? '#eb4d4b' : '#f39c12', padding: '8px 20px', borderRadius: '20px', textTransform: 'uppercase' }}>{car.status}</span>
                  </div>
                </div>
              )) : <p style={{ color: '#ccc', fontWeight: 'bold', textAlign: 'center', padding: '50px' }}>You haven't listed any cars yet.</p>}
            </div>
          )}

          {currentTab === 'Wishlist' && (
            <div className="grid-2-cols" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
              {favCars.length > 0 ? favCars.map(fav => {
                const car = fav.expand?.car_id; if(!car) return null;
                return (
                  <div key={fav.id} onClick={() => { setSelectedCar(car); setView('details'); }} style={{ background: '#fff', padding: '20px', borderRadius: '30px', border: '1px solid #eee', cursor: 'pointer', boxShadow: '0 5px 15px rgba(0,0,0,0.03)', transition: '0.3s' }}>
                    <img src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${getVal(car.image)}`} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '20px' }} alt="" />
                    <h4 style={{ margin: '20px 0 8px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '18px' }}>{car.brand} {car.model}</h4>
                    <p style={{ margin: '0 0 15px 0', fontSize: '12px', color: '#aaa', fontWeight: 'bold' }}>{car.year} • {car.kilometers_driven} km</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                      <span style={{ fontWeight: '900', color: '#ef5e33', fontSize: '20px' }}>₹{car.price?.toLocaleString()}</span>
                      <button onClick={(e) => { e.stopPropagation(); deleteRecord('wishlist', fav.id); }} style={{ background: '#ffebeb', border: 'none', color: '#eb4d4b', padding: '10px', borderRadius: '50%', cursor: 'pointer', fontSize: '14px' }}>🗑️</button>
                    </div>
                  </div>
                );
              }) : <p style={{ color: '#ccc', fontWeight: 'bold', textAlign: 'center', padding: '50px', gridColumn: '1/-1' }}>Your wishlist is empty.</p>}
            </div>
          )}

          {currentTab === 'Analytics' && (
            <div className="grid-3-cols">
              <div style={{ padding: '50px 20px', backgroundColor: '#fff', borderRadius: '30px', border: '1px solid #eee', textAlign: 'center', boxShadow: '0 5px 15px rgba(0,0,0,0.02)' }}><h1 style={{ fontSize: '64px', color: '#ef5e33', margin: '0 0 10px 0', fontWeight: '900' }}>{myCars.length}</h1><p style={{ color: '#888', fontWeight: '900', fontSize: '14px', textTransform: 'uppercase', margin: 0 }}>Cars Listed</p></div>
              <div style={{ padding: '50px 20px', backgroundColor: '#fff', borderRadius: '30px', border: '1px solid #eee', textAlign: 'center', boxShadow: '0 5px 15px rgba(0,0,0,0.02)' }}><h1 style={{ fontSize: '64px', color: '#002f34', margin: '0 0 10px 0', fontWeight: '900' }}>{myBookings.length}</h1><p style={{ color: '#888', fontWeight: '900', fontSize: '14px', textTransform: 'uppercase', margin: 0 }}>Total Bookings</p></div>
              <div style={{ padding: '50px 20px', backgroundColor: '#fff', borderRadius: '30px', border: '1px solid #eee', textAlign: 'center', boxShadow: '0 5px 15px rgba(0,0,0,0.02)' }}><h1 style={{ fontSize: '64px', color: '#1db954', margin: '0 0 10px 0', fontWeight: '900' }}>{myOrders.length}</h1><p style={{ color: '#888', fontWeight: '900', fontSize: '14px', textTransform: 'uppercase', margin: 0 }}>Cars Bought</p></div>
            </div>
          )}

          {/* 🚨 UPDATED: CUSTOMER WALLET WITH RAZORPAY INTEGRATION 🚨 */}
          {currentTab === 'Wallet' && (
            <div style={{ textAlign: 'center', padding: '50px 20px', background: 'linear-gradient(135deg, #002f34 0%, #004d56 100%)', borderRadius: '40px', color: '#fff', boxShadow: '0 15px 40px rgba(0,47,52,0.3)', maxWidth: '600px', margin: '0 auto' }}>
              <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#88b5b9', margin: '0 0 10px 0', textTransform: 'uppercase', letterSpacing: '2px' }}>Available Balance</p>
              <h1 style={{ fontSize: '50px', margin: '0 0 30px 0', fontWeight: '900' }}>₹{(userData.wallet_balance || 0).toLocaleString()}</h1>
              
              <div style={{ backgroundColor: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '30px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', border: '1px solid rgba(255,255,255,0.15)' }}>
                <p style={{ margin: 0, fontSize: '13px', color: '#fff', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>Quick Recharge</p>
                
                <div style={{ width: '100%', maxWidth: '350px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', color: '#002f34', fontWeight: '900', fontSize: '20px' }}>₹</span>
                  <input 
                    type="number" 
                    placeholder="Enter Amount" 
                    value={rechargeAmount}
                    onChange={(e) => setRechargeAmount(e.target.value)}
                    style={{ width: '100%', padding: '20px 20px 20px 50px', borderRadius: '20px', border: 'none', fontSize: '18px', fontWeight: 'bold', outline: 'none', color: '#002f34', boxSizing: 'border-box' }}
                  />
                </div>

                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
                  {[500, 1000, 5000, 10000].map(amt => (
                    <button 
                      key={amt} 
                      onClick={() => setRechargeAmount(amt.toString())} 
                      style={{ padding: '8px 15px', borderRadius: '10px', backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', transition: '0.2s' }}
                    >
                      +₹{amt}
                    </button>
                  ))}
                </div>

                <button 
                  disabled={isRecharging}
                  onClick={handleWalletRecharge} 
                  style={{ width: '100%', maxWidth: '350px', padding: '20px', backgroundColor: isRecharging ? '#ccc' : '#ef5e33', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: '900', fontSize: '16px', cursor: isRecharging ? 'not-allowed' : 'pointer', textTransform: 'uppercase', boxShadow: isRecharging ? 'none' : '0 10px 25px rgba(239,94,51,0.4)', transition: '0.3s' }}
                >
                  {isRecharging ? 'Processing...' : 'Proceed to Pay'}
                </button>
              </div>
            </div>
          )}

          {currentTab === 'My Address' && (
            <form onSubmit={handleAddressUpdate} autoComplete="off" style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '600px', backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '30px', margin: '0 auto' }}>
              
              <div style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '15px', borderLeft: '4px solid #ef5e33', fontSize: '13px', color: '#555', fontWeight: 'bold' }}>
                💡 We will use this address for delivering your dream car safely to your doorstep.
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Street Address / Flat No.</label>
                <input 
                  type="text" 
                  placeholder="e.g. 12/A Park Street"
                  value={addressData.address_line} 
                  autoComplete="off"
                  onChange={(e) => setAddressData({...addressData, address_line: e.target.value})} 
                  style={inputStyle} 
                  required
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Landmark (Optional)</label>
                <input 
                  type="text" 
                  placeholder="e.g. Near Axis Bank"
                  value={addressData.landmark} 
                  autoComplete="off"
                  onChange={(e) => setAddressData({...addressData, landmark: e.target.value})} 
                  style={inputStyle} 
                />
              </div>

              <div className="grid-2-cols">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>State</label>
                  <select 
                    value={addressData.state} 
                    onChange={(e) => setAddressData({...addressData, state: e.target.value})} 
                    style={inputStyle} 
                    required
                  >
                    <option value="">Select State</option>
                    {STATES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>City</label>
                  <select 
                    value={addressData.city} 
                    onChange={(e) => setAddressData({...addressData, city: e.target.value})} 
                    style={inputStyle} 
                    required
                  >
                    <option value="">Select City</option>
                    {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>PIN Code</label>
                <input 
                  type="text" 
                  maxLength="6"
                  placeholder="e.g. 700001"
                  value={addressData.pin_code} 
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    setAddressData({...addressData, pin_code: val});
                  }} 
                  style={inputStyle} 
                  required
                />
              </div>

              <button type="submit" style={{ padding: '18px', backgroundColor: '#ef5e33', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: '900', textTransform: 'uppercase', cursor: 'pointer', marginTop: '10px', boxShadow: '0 10px 20px rgba(239,94,51,0.2)', transition: '0.3s' }}>
                Save Address
              </button>
            </form>
          )}

          {currentTab === 'Profile Update' && (
            <form onSubmit={handleProfileUpdate} autoComplete="off" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px', maxWidth: '500px', backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '30px', margin: '0 auto' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Profile Picture</label>
                <input type="file" accept="image/*" onChange={(e) => setProfileImage(e.target.files[0])} style={{ padding: '15px', borderRadius: '15px', border: '2px dashed #ccc', backgroundColor: '#fff', fontWeight: 'bold', cursor: 'pointer', width: '100%', boxSizing: 'border-box' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Full Name</label>
                <input 
                  type="text" 
                  value={profileData.name} 
                  autoComplete="off"
                  onChange={(e) => setProfileData({...profileData, name: e.target.value})} 
                  style={inputStyle} 
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>Phone Number</label>
                <input 
                  type="text" 
                  maxLength="10"
                  autoComplete="off"
                  value={profileData.phone} 
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    setProfileData({...profileData, phone: val});
                  }} 
                  style={inputStyle} 
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '11px', fontWeight: '900', color: '#999', textTransform: 'uppercase' }}>City</label>
                <select 
                  value={profileData.city} 
                  onChange={(e) => setProfileData({...profileData, city: e.target.value})} 
                  style={inputStyle}
                >
                  <option value="">Select City</option>
                  {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <button type="submit" style={{ padding: '18px', backgroundColor: '#002f34', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: '900', textTransform: 'uppercase', cursor: 'pointer', marginTop: '10px', boxShadow: '0 10px 20px rgba(0,47,52,0.2)' }}>
                Save Changes
              </button>
            </form>
          )}
        </section>

      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default Account;